export interface IBusinessBioState {
  yearCompanyWasFounded: string;
  numberOfPermanentEmployees: string;
  unionizedCompany: 'yes' | 'no';
  supplierCompanyOwnership: string;
  updatedDate?: string;
}

export const BusinessBioState: IBusinessBioState = {
  yearCompanyWasFounded: '',
  numberOfPermanentEmployees: '',
  unionizedCompany: 'no',
  supplierCompanyOwnership: 'Privately Owned'
};

export interface IBusinessInfoState {
  companyLegalName: string;
  companyDoingBusinessAs: string;
  companyParentCompany: string;
  companyPhoneNumber: string;
  companyWebsite: string;
  companyEmailAddress: string;
  companyTaxIdNumber: string;
  dunsNumber: string;
  primaryNAICSCode: string;
  secondaryNAICSCode: string;
  annualSale1: string; //must be replace at the submit using the last year since it´s dynamic ex: 2020
  annualSale2: string; //must be replace at the submit using the year before ex: 2019
  annualSale3: string; //must be replace at the submit using the year before ex: 2018
}

export interface IBusinessDataTagResponse {
  id: number;
  questionId: number;
  questionName: string;
  questionAnswer: string | boolean;
}

export interface IBusinessTagResponse {
  updatedDate: string;
  businessBiography: IBusinessDataTagResponse[];
  businessInformation: IBusinessDataTagResponse[];
}

export const BusinessInfoState: IBusinessInfoState = {
  companyLegalName: '',
  companyDoingBusinessAs: '',
  companyParentCompany: '',
  companyPhoneNumber: '',
  companyWebsite: '',
  companyEmailAddress: '',
  companyTaxIdNumber: '',
  dunsNumber: '',
  primaryNAICSCode: '',
  secondaryNAICSCode: '',
  annualSale1: '',
  annualSale2: '',
  annualSale3: ''
};
